module.exports = __webpack_public_path__ + "static/img/qrcode.db14582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qrcode.png
// module id = cgBV
// module chunks = 8